import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const LandingPageSubheader = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14921)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FFEDBF"
          />
          <path
            d="M176.954 41.8522V114.831C176.954 117.251 175.993 119.571 174.282 121.282C172.571 122.993 170.251 123.954 167.831 123.954H81.1686C78.7492 123.954 76.4289 122.993 74.7181 121.282C73.0073 119.571 72.0462 117.251 72.0462 114.831V41.8522H176.954Z"
            fill="#66E1FF"
          />
          <path
            d="M72.0462 41.8522V114.831C72.0462 117.251 73.0073 119.571 74.7181 121.282C76.4289 122.993 78.7492 123.954 81.1686 123.954H85.7298L167.831 41.8522H72.0462Z"
            fill="#C2F3FF"
          />
          <path
            d="M176.954 41.8523H72.0462V28.1687C72.0462 25.7493 73.0073 23.4289 74.7181 21.7182C76.4289 20.0074 78.7492 19.0463 81.1686 19.0463H167.831C170.251 19.0463 172.571 20.0074 174.282 21.7182C175.993 23.4289 176.954 25.7493 176.954 28.1687V41.8523Z"
            fill="white"
          />
          <path
            d="M167.831 19.0463H81.1686C78.7492 19.0463 76.4289 20.0074 74.7181 21.7182C73.0073 23.4289 72.0462 25.7493 72.0462 28.1687V114.831C72.0462 117.251 73.0073 119.571 74.7181 121.282C76.4289 122.993 78.7492 123.954 81.1686 123.954H167.831C170.251 123.954 172.571 122.993 174.282 121.282C175.993 119.571 176.954 117.251 176.954 114.831V28.1687C176.954 25.7493 175.993 23.4289 174.282 21.7182C172.571 20.0074 170.251 19.0463 167.831 19.0463Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.0462 41.8522H176.954"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.0104 31.5896C87.708 31.5896 87.418 31.4694 87.2041 31.2556C86.9903 31.0417 86.8701 30.7517 86.8701 30.4493C86.8701 30.1468 86.9903 29.8568 87.2041 29.6429C87.418 29.4291 87.708 29.309 88.0104 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M88.0104 31.5896C88.3129 31.5896 88.6029 31.4694 88.8167 31.2556C89.0306 31.0417 89.1507 30.7517 89.1507 30.4493C89.1507 30.1468 89.0306 29.8568 88.8167 29.6429C88.6029 29.4291 88.3129 29.309 88.0104 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M160.99 50.8275H88.0104C87.4055 50.8275 86.8255 51.0678 86.3978 51.4955C85.9701 51.9232 85.7298 52.5033 85.7298 53.1081V62.2305C85.7298 62.8354 85.9701 63.4154 86.3978 63.8431C86.8255 64.2708 87.4055 64.5111 88.0104 64.5111H160.99C161.594 64.5111 162.174 64.2708 162.602 63.8431C163.03 63.4154 163.27 62.8354 163.27 62.2305V53.1081C163.27 52.5033 163.03 51.9232 162.602 51.4955C162.174 51.0678 161.594 50.8275 160.99 50.8275Z"
            fill="#FFEF5E"
          />
          <path
            d="M88.0104 50.8275C87.4055 50.8275 86.8255 51.0678 86.3978 51.4955C85.9701 51.9232 85.7298 52.5033 85.7298 53.1081V62.2305C85.7298 62.8354 85.9701 63.4154 86.3978 63.8431C86.8255 64.2708 87.4055 64.5111 88.0104 64.5111H140.464L154.148 50.8275H88.0104Z"
            fill="#FFF9BF"
          />
          <path
            d="M160.99 50.8275H88.0104C87.4055 50.8275 86.8255 51.0678 86.3978 51.4955C85.9701 51.9232 85.7298 52.5033 85.7298 53.1081V62.2305C85.7298 62.8354 85.9701 63.4154 86.3978 63.8431C86.8255 64.2708 87.4055 64.5111 88.0104 64.5111H160.99C161.594 64.5111 162.174 64.2708 162.602 63.8431C163.03 63.4154 163.27 62.8354 163.27 62.2305V53.1081C163.27 52.5033 163.03 51.9232 162.602 51.4955C162.174 51.0678 161.594 50.8275 160.99 50.8275Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g clipPath="url(#clip1_1503_14921)">
            <path
              d="M100.597 102.75H147.403C148.445 102.75 149.445 103.164 150.182 103.901C150.919 104.638 151.333 105.638 151.333 106.681V144.125C151.333 145.167 150.919 146.167 150.182 146.904C149.445 147.641 148.445 148.055 147.403 148.055H100.597C99.5548 148.055 98.5551 147.641 97.818 146.904C97.0809 146.167 96.6667 145.167 96.6667 144.125V106.681C96.6667 105.638 97.0809 104.638 97.818 103.901C98.5551 103.164 99.5548 102.75 100.597 102.75Z"
              fill="#FFEF5E"
              stroke="#191919"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <mask
              id="path-13-inside-1_1503_14921"
              fill="white"
            >
              <path d="M96.4204 104.837L149.749 143.613L96.4204 104.837Z" />
            </mask>
            <path
              d="M97.3025 103.624C96.6325 103.137 95.6944 103.285 95.2072 103.955C94.72 104.625 94.8683 105.563 95.5383 106.051L97.3025 103.624ZM148.867 144.827C149.537 145.314 150.475 145.166 150.963 144.495C151.45 143.825 151.302 142.887 150.632 142.4L148.867 144.827ZM95.5383 106.051L148.867 144.827L150.632 142.4L97.3025 103.624L95.5383 106.051Z"
              fill="#191919"
              mask="url(#path-13-inside-1_1503_14921)"
            />
          </g>
          <path
            d="M117.805 76.5625H163.417"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.805 85.6846H154"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.694 31.5896C101.392 31.5896 101.102 31.4694 100.888 31.2556C100.674 31.0417 100.554 30.7517 100.554 30.4493C100.554 30.1468 100.674 29.8568 100.888 29.6429C101.102 29.4291 101.392 29.309 101.694 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M101.694 31.5896C101.996 31.5896 102.286 31.4694 102.5 31.2556C102.714 31.0417 102.834 30.7517 102.834 30.4493C102.834 30.1468 102.714 29.8568 102.5 29.6429C102.286 29.4291 101.996 29.309 101.694 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M115.378 31.5896C115.075 31.5896 114.785 31.4694 114.571 31.2556C114.357 31.0417 114.237 30.7517 114.237 30.4493C114.237 30.1468 114.357 29.8568 114.571 29.6429C114.785 29.4291 115.075 29.309 115.378 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M115.378 31.5896C115.68 31.5896 115.97 31.4694 116.184 31.2556C116.398 31.0417 116.518 30.7517 116.518 30.4493C116.518 30.1468 116.398 29.8568 116.184 29.6429C115.97 29.4291 115.68 29.309 115.378 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <g clipPath="url(#clip2_1503_14921)">
            <path
              d="M98 103L150.5 141.5"
              stroke="#191919"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M98.9812 141.5L149.023 103"
              stroke="#191919"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M107 72C107 71.4477 107.448 71 108 71H196C196.552 71 197 71.4477 197 72V93.058C197 93.6103 196.552 94.058 196 94.058H108C107.448 94.058 107 93.6103 107 93.058V72Z"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="2"
          />
          <path
            d="M112.528 78.9022V77.7153C112.528 77.4005 112.653 77.0986 112.876 76.876C113.099 76.6534 113.4 76.5283 113.715 76.5283H122.024C122.339 76.5283 122.641 76.6534 122.863 76.876C123.086 77.0986 123.211 77.4005 123.211 77.7153V78.9022"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.869 76.5283V87.2109"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115.496 87.2109H120.244"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M126.442 87.8047H136.993"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14921">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1503_14921">
            <rect
              width="58"
              height="21"
              fill="white"
              transform="translate(95 102)"
            />
          </clipPath>
          <clipPath id="clip2_1503_14921">
            <rect
              width="52.5"
              height="21"
              fill="white"
              transform="translate(98 103)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
